<template>
  <section class="lpg-main">
    <Head title="Empresas" />
    <!-- Start nav -->
    <div class="container-fluid px-0">
      <nav class="navbar navbar-expand-lg navbar-light lpg-bg-green py-3 lpg-main-menu">
        <div class="container-fluid">
          <Link class="navbar-brand" :href="$route('company.dashboard')">
            <img src="/images/icono.png" class="w-50" />
          </Link>

          <input type="checkbox" id="navbar-toggle-cbox" />
          <label
            for="navbar-toggle-cbox"
            class="navbar-toggler collapsed"
            data-toggle="collapse"
            data-target="#navbar"
            aria-expanded="false"
            aria-controls="navbar"
          >
            <span class="visually-hidden">Toggle navigation</span>
            <span class="navbar-toggler-icon"></span>
          </label>
          <NavBarAuthenticatedEmpresas v-if="user !== null"></NavBarAuthenticatedEmpresas>
        </div>
      </nav>
    </div>
    <!-- End nav -->
    <div v-if="$page.props.flash.message" class="alert alert-secondary text-center fw-bold">
      {{ $page.props.flash.message }}
    </div>
    <slot />
    <!-- Start partners -->
    <footer class="w-100">
      <div class="my-5">
        <p class="text-center">Grupo LPG. Todos los derechos reservados.</p>
      </div>
    </footer>
    <!-- End partners -->
  </section>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue'
import NavBarAuthenticatedEmpresas from '@/Layouts/NavBarAuthenticatedEmpresas.vue'
import SponsorCarousel from '@/Components/SponsorCarousel.vue'

export default {
  name: 'LayoutEmpresas',
  components: {
    Link,
    Head,
    NavBarAuthenticatedEmpresas,
    SponsorCarousel,
  },
  computed: {
    user() {
      return this.$page.props.auth.user
    },
  },
}
</script>
